module.exports = __webpack_public_path__ + "static/media/commerce2.2ddf03cc.webp";